import React from "react";
import PropTypes from 'prop-types';
import "./statusDot.scss";
function URStatusDot(props: any) {
  let {className } = props;
  return (
    <>
      <span className={className}></span>
    </>

  );
}

export {
  URStatusDot
};

URStatusDot.propTypes = {
  className: PropTypes.any
};